/*---------------------------------------*

	FILTER MAPPING HANDLER

----------------------------------------*/

window.filterMappingHandler = {

    

    getCurrentFilterOptions(){

        
        if(!window.vueInstance.$store.state.chosenArticleFilter.length)
            return []

        var filterList = [];
        $.each(window.vueInstance.$store.state.chosenArticleFilter, function(index, value){
            filterList.push(value.id)
        })

        return filterList;

    },

	getIDFromSize(size){
	
        switch(size) {
            case '13x18':
                return 24;
                break;
            case '21x30':
                return 15;
                break;
            case '30x40':
                return 4;
                break;
            case '40x50':
                return 32;
                break;
            case '50x50':
                return 43;
                break;
            case '50x70':
                return 8;
                break;
            case '70x100':
                return 28;
                break;
        }

	},

    getIDFromFormat(format){
		switch(format) {
            case 'portrait':
                return 3;
                break;
            case 'landscape':
                return 26;
                break;
            case 'square':
                return 42;
                break;
        }
	},

};



// WEBPACK FOOTER //
// ./client/filterMapping.js